import { css, keyframes } from 'goober';
import { getRandomInt } from 'mc-ui-utils';
import React, { useState } from 'react';
import ThumbDown from '../../assets/thumb_down.svg';
import ThumbUp from '../../assets/thumb_up.svg';
import { DISLIKE_TITLE, LIKE_DISLIKE_MESSAGE, LIKE_TITLE, MAX_LIKES, MIN_LIKES, } from '../../constants/interaction';
import colors from '../../styles/colors';
import font, { fontBase } from '../../styles/font';
import IconBubbles from '../IconBubbles';
const Wrapper = css `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
`;
const Container = css `
  display: flex;
`;
const IconContainer = (marginLeft) => css `
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 50%;
  margin-left: ${marginLeft}px;
`;
const RotateAndScale = (rotateDeg) => keyframes `
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(${rotateDeg}deg) scale(0.7);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
`;
const RotateAndScaleAnimation = (rotateDeg) => css `
  animation-name: ${RotateAndScale(rotateDeg)};
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
`;
const MessageContainer = css `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: -1;
`;
const MoveUpIcon = keyframes `
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  40%, 50%, 60% {
    transform: translateY(-100px);
    opacity: 1;
  }
  100% {
    transform: translateY(-120px);
    opacity: 0;
  }
`;
const MessageIcon = css `
  position: absolute;
  animation-name: ${MoveUpIcon};
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
`;
const RotateIcon = css `
  transform: rotate(-15deg);
`;
const MessageAnimation = keyframes `
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  40%, 50%, 60% {
    transform: translateY(-55px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 0;
  }
`;
const Message = css `
  position: absolute;
  text-align: center;
  animation-name: ${MessageAnimation};
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
`;
const TextShadow = `
  2px 0 0 #fff, -2px 0 0 #fff, 0 2px 0 #fff, 0 -2px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff;
`;
const MessageTitle = (option) => css `
  font-size: ${26 / fontBase}rem;
  font-weight: ${font.fontWtBlack};
  line-height: 33px;
  text-shadow: ${TextShadow};
  color: ${option === 'like' ? colors.bubbleBlue : colors.bubbleRed};
`;
const MessageText = css `
  font-size: ${font.fontTiny};
  font-weight: ${font.fontWtBold};
  line-height: 13px;
`;
const MessageSubtext = css `
  font-size: ${font.fontTiny};
  line-height: 13px;
`;
const Icon = ({ rotateDeg, children, marginLeft = 0, onVariantClick, onShowMessage, isAnimating, }) => {
    const [rotate, setRotate] = useState(false);
    const handleClick = () => {
        if (!isAnimating) {
            setRotate(true);
            onVariantClick();
        }
    };
    const handleAnimationEnd = () => {
        setRotate(false);
        onShowMessage();
    };
    return (React.createElement("div", { className: `${IconContainer(marginLeft)} ${rotate ? RotateAndScaleAnimation(rotateDeg) : ''}`, onClick: handleClick, onAnimationEnd: handleAnimationEnd }, children));
};
const LikeDislike = (props) => {
    const { onSendAnalytics } = props;
    const [showMessage, setShowMessage] = useState(false);
    const [value, setValue] = useState(null);
    const handleShowMessage = (show) => () => setShowMessage(show);
    const handleClick = (option) => () => {
        setValue(option);
        onSendAnalytics({
            variant: "likeDislike" /* LIKE_DISLIKE */,
            action: `${option} selected with icon id - ${option === 'like'
                ? "thumbs_up" /* THUMBS_UP */
                : "thumbs_down" /* THUMBS_DOWN */}`,
        });
    };
    const likes = getRandomInt(MIN_LIKES, MAX_LIKES);
    return (React.createElement("div", { className: Wrapper },
        React.createElement("div", { className: Container },
            React.createElement(Icon, { rotateDeg: -25, isAnimating: showMessage, onShowMessage: handleShowMessage(true), onVariantClick: handleClick('dislike') },
                React.createElement("img", { src: ThumbDown, alt: "Thumb down", width: "20px", height: "20px" })),
            React.createElement(Icon, { rotateDeg: 25, isAnimating: showMessage, onShowMessage: handleShowMessage(true), onVariantClick: handleClick('like'), marginLeft: 32 },
                React.createElement("img", { src: ThumbUp, alt: "Thumb up", width: "20px", height: "20px" }))),
        showMessage ? (React.createElement("div", { className: MessageContainer },
            React.createElement("div", { className: MessageIcon, onAnimationEnd: handleShowMessage(false) }, value === 'like' ? (React.createElement(React.Fragment, null,
                React.createElement("img", { src: ThumbUp, alt: "Thumb up", width: "36px", height: "36px", className: RotateIcon }),
                React.createElement(IconBubbles, { color: colors.blueGradient }))) : (React.createElement(React.Fragment, null,
                React.createElement("img", { src: ThumbDown, alt: "Thumb down", width: "36px", height: "36px", className: RotateIcon }),
                React.createElement(IconBubbles, { color: colors.redGradient })))),
            React.createElement("div", { className: Message },
                React.createElement("div", { className: MessageText }, value === 'like' ? LIKE_TITLE : DISLIKE_TITLE),
                React.createElement("div", { className: MessageTitle(value) },
                    value === 'like' ? likes : 100 - likes,
                    "%"),
                React.createElement("div", { className: MessageSubtext }, LIKE_DISLIKE_MESSAGE)))) : null));
};
export default LikeDislike;
//# sourceMappingURL=index.js.map